import { ADDITEM, REMOVEITEM } from "./actionType";

const initialstate = {
  items: [],
};

const actionReducer = (state = initialstate, action) => {
  switch (action.type) {
    case ADDITEM:
      return {
        ...state,
        items: [...state.items, action.payload],
      };
    case REMOVEITEM:
      return {
        ...state,
        items: state.items.filter((e) => e.id !== action.payload.id),
      };
    default:
      return state;
  }
};

export default actionReducer;
